var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-9"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 391.92,
    width: 21.21,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.14,
    y: 389.21,
    width: 84.97,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.67,
    y: 401.21,
    width: 38.11,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.71,
    y: 399.53,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.47,
    y: 399.53,
    width: 11.97,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.89,
    y: 395.31,
    width: 23,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.89,
    y: 395.31,
    width: 48.44,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.31,215.53l7.41-7.41A40.13,40.13,0,0,1,321,275.26l2.71-10.12a29.65,29.65,0,0,0,28.65-49.61Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,208.12a40.17,40.17,0,0,1,56.76,0l-7.41,7.41a29.66,29.66,0,0,0-41.94,0Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,208.12l7.41,7.41a29.65,29.65,0,0,0,0,41.94,29.31,29.31,0,0,0,13.29,7.67L321,275.26a40.14,40.14,0,0,1-18-67.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.26,178.45v15.72A60.26,60.26,0,0,1,355.13,81.72L363,95.34a44.53,44.53,0,0,0,22.26,83.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.52,133.91a60.28,60.28,0,0,1-60.26,60.26V178.45a44.55,44.55,0,0,0,44.54-44.54Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.52,133.91H429.8A44.53,44.53,0,0,0,363,95.34l-7.86-13.62a60.26,60.26,0,0,1,90.38,52.19Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 280.94,
    y: 325.95,
    width: 26.72,
    height: 56.45,
    transform: "translate(588.59 708.34) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.77,
    y: 342.97,
    width: 26.72,
    height: 39.42,
    transform: "translate(524.25 725.37) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.6,
    y: 357.49,
    width: 26.72,
    height: 24.91,
    transform: "translate(459.91 739.88) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.18,
    y: 342.97,
    width: 26.72,
    height: 39.42,
    transform: "translate(789.07 725.37) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349,
    y: 351.69,
    width: 26.72,
    height: 30.7,
    transform: "translate(724.73 734.09) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.83,
    y: 316.26,
    width: 26.72,
    height: 66.13,
    transform: "translate(660.38 698.66) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.7,
    y: 320.69,
    width: 26.72,
    height: 61.7,
    transform: "translate(388.11 703.09) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.53,
    y: 342.97,
    width: 26.72,
    height: 39.42,
    transform: "translate(323.77 725.37) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.36,
    y: 330.52,
    width: 26.72,
    height: 51.88,
    transform: "translate(259.43 712.92) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.11,79.46a6.84,6.84,0,0,1,6.81-6.81H275.18A6.84,6.84,0,0,1,282,79.46V101.4H56.11Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.2,92.68A5.66,5.66,0,1,1,116.86,87,5.67,5.67,0,0,1,111.2,92.68Zm0-10.31A4.66,4.66,0,1,0,115.86,87,4.66,4.66,0,0,0,111.2,82.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,92.68A5.66,5.66,0,1,1,98.6,87,5.66,5.66,0,0,1,93,92.68Zm0-10.31A4.66,4.66,0,1,0,97.6,87,4.65,4.65,0,0,0,93,82.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.69,92.68A5.66,5.66,0,1,1,80.34,87,5.67,5.67,0,0,1,74.69,92.68Zm0-10.31A4.66,4.66,0,1,0,79.34,87,4.66,4.66,0,0,0,74.69,82.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.18,249.12H62.92a6.84,6.84,0,0,1-6.81-6.81V101.4H282V242.31A6.84,6.84,0,0,1,275.18,249.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.58,132.3a6.83,6.83,0,0,1,6.81-6.82H309.65a6.84,6.84,0,0,1,6.81,6.82v21.93H90.58Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.67,145.51a5.66,5.66,0,1,1,5.65-5.65A5.66,5.66,0,0,1,145.67,145.51Zm0-10.31a4.66,4.66,0,1,0,4.65,4.66A4.66,4.66,0,0,0,145.67,135.2Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.41,145.51a5.66,5.66,0,1,1,5.65-5.65A5.66,5.66,0,0,1,127.41,145.51Zm0-10.31a4.66,4.66,0,1,0,4.65,4.66A4.66,4.66,0,0,0,127.41,135.2Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.16,145.51a5.66,5.66,0,1,1,5.65-5.65A5.67,5.67,0,0,1,109.16,145.51Zm0-10.31a4.66,4.66,0,1,0,4.65,4.66A4.66,4.66,0,0,0,109.16,135.2Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.65,302H97.39a6.82,6.82,0,0,1-6.81-6.81V154.23H316.46V295.14A6.83,6.83,0,0,1,309.65,302Z",
    style: {
      fill: "#e6e6e6"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-9"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-9",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Smartphone--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.52,163.36a2.45,2.45,0,0,0,2.47-2.59L268.25,146a2.76,2.76,0,0,0-2.72-2.6h-2l-1.81-36.75A15.58,15.58,0,0,0,246.42,92H131.33a13.82,13.82,0,0,0-13.89,14.62l1.82,36.92a2.59,2.59,0,0,0-1.7,2.58l1.75,35.43a2.93,2.93,0,0,0,2,2.58L129,340.48a15.58,15.58,0,0,0,15.34,14.62H259.42a13.82,13.82,0,0,0,13.89-14.62l-7.45-150.7h2a2.45,2.45,0,0,0,2.47-2.59l-.73-14.8a2.77,2.77,0,0,0-2.72-2.59h-2l-.32-6.44Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.77,355.1H261.85a13.83,13.83,0,0,0,13.9-14.62L264.19,106.63A15.57,15.57,0,0,0,248.86,92H133.77a13.83,13.83,0,0,0-13.9,14.62l11.56,233.85A15.58,15.58,0,0,0,146.77,355.1Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.77,355.1H261.85a13.83,13.83,0,0,0,13.9-14.62L264.19,106.63A15.57,15.57,0,0,0,248.86,92H133.77a13.83,13.83,0,0,0-13.9,14.62l11.56,233.85A15.58,15.58,0,0,0,146.77,355.1Z",
    style: {
      fill: "#fafafa",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.32,334.71h132a2.15,2.15,0,0,0,2.17-2.27L260.71,115.17a2.42,2.42,0,0,0-2.39-2.27h-132a2.14,2.14,0,0,0-2.16,2.27l10.73,217.27A2.42,2.42,0,0,0,137.32,334.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.52,98.77H177.77a1.7,1.7,0,0,0-1.71,1.8h0a1.92,1.92,0,0,0,1.89,1.81H205.7a1.7,1.7,0,0,0,1.71-1.81h0A1.92,1.92,0,0,0,205.52,98.77Z",
    style: {
      fill: "#FFFFFF",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.02 289.49 191.64 289.49 183.37 122.13 298.75 122.13 307.02 289.49",
    style: {
      fill: "#FFFFFF",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.4,243.73a.45.45,0,0,1-.16,0,.3.3,0,0,1-.13-.09.38.38,0,0,1-.09-.13.47.47,0,0,1,0-.16.42.42,0,0,1,.84,0,.47.47,0,0,1,0,.16.38.38,0,0,1-.09.13.3.3,0,0,1-.13.09A.41.41,0,0,1,293.4,243.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.55,275a.41.41,0,0,1,.39-.43h0a.42.42,0,0,1,.44.39h0a.42.42,0,0,1-.4.44h0A.42.42,0,0,1,294.55,275Zm-.16-3.16a.42.42,0,0,1,.4-.44h0a.41.41,0,0,1,.43.4h0a.41.41,0,0,1-.39.43h0A.42.42,0,0,1,294.39,271.84Zm-.15-3.17a.41.41,0,0,1,.39-.43h0a.4.4,0,0,1,.43.39h0a.41.41,0,0,1-.39.44h0A.42.42,0,0,1,294.24,268.67Zm-.16-3.17a.42.42,0,0,1,.39-.43h0a.42.42,0,0,1,.44.39h0a.42.42,0,0,1-.39.44h0A.42.42,0,0,1,294.08,265.5Zm-.16-3.16a.42.42,0,0,1,.4-.44h0a.41.41,0,0,1,.43.4h0a.41.41,0,0,1-.39.43h0A.42.42,0,0,1,293.92,262.34Zm-.15-3.17a.41.41,0,0,1,.39-.43h0a.41.41,0,0,1,.44.39h0a.43.43,0,0,1-.4.44h0A.42.42,0,0,1,293.77,259.17Zm-.16-3.17a.42.42,0,0,1,.4-.43h0a.41.41,0,0,1,.43.39h0a.42.42,0,0,1-.39.44h0A.42.42,0,0,1,293.61,256Zm-.15-3.16a.41.41,0,0,1,.39-.44h0a.41.41,0,0,1,.43.4h0a.41.41,0,0,1-.39.43h0A.41.41,0,0,1,293.46,252.84Zm-.16-3.17a.41.41,0,0,1,.39-.43h0a.42.42,0,0,1,.44.39h0a.43.43,0,0,1-.4.44h0A.42.42,0,0,1,293.3,249.67Zm-.16-3.16a.42.42,0,0,1,.4-.44h0a.41.41,0,0,1,.43.39h0a.42.42,0,0,1-.39.44h0A.42.42,0,0,1,293.14,246.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.12,278.57a.39.39,0,0,1-.29-.13.38.38,0,0,1-.12-.29.45.45,0,0,1,0-.16.3.3,0,0,1,.09-.13.38.38,0,0,1,.13-.09.44.44,0,0,1,.32,0,.42.42,0,0,1,.14.09.41.41,0,0,1,.08.13.32.32,0,0,1,0,.16.43.43,0,0,1-.12.29.42.42,0,0,1-.14.09A.29.29,0,0,1,295.12,278.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.35,278.15a.41.41,0,0,1,.42-.41h0a.41.41,0,0,1,.41.41h0a.42.42,0,0,1-.41.42h0A.42.42,0,0,1,291.35,278.15Zm-3.36,0a.41.41,0,0,1,.42-.41h0a.41.41,0,0,1,.41.41h0a.41.41,0,0,1-.41.42h0A.42.42,0,0,1,288,278.15Zm-3.35,0a.41.41,0,0,1,.41-.41h0a.41.41,0,0,1,.42.41h0a.42.42,0,0,1-.42.42h0A.41.41,0,0,1,284.64,278.15Zm-3.36,0a.41.41,0,0,1,.42-.41h0a.41.41,0,0,1,.41.41h0a.41.41,0,0,1-.41.42h0A.42.42,0,0,1,281.28,278.15Zm-3.35,0a.41.41,0,0,1,.41-.41h0a.41.41,0,0,1,.42.41h0a.42.42,0,0,1-.42.42h0A.41.41,0,0,1,277.93,278.15Zm-3.36,0a.41.41,0,0,1,.42-.41h0a.41.41,0,0,1,.41.41h0a.41.41,0,0,1-.41.42h0A.42.42,0,0,1,274.57,278.15Zm-3.36,0a.41.41,0,0,1,.42-.41h0a.41.41,0,0,1,.41.41h0a.41.41,0,0,1-.41.42h0A.42.42,0,0,1,271.21,278.15Zm-3.35,0a.41.41,0,0,1,.41-.41h0a.41.41,0,0,1,.42.41h0a.42.42,0,0,1-.42.42h0A.42.42,0,0,1,267.86,278.15Zm-3.36,0a.41.41,0,0,1,.42-.41h0a.41.41,0,0,1,.41.41h0a.41.41,0,0,1-.41.42h0A.42.42,0,0,1,264.5,278.15Zm-3.35,0a.41.41,0,0,1,.41-.41h0a.41.41,0,0,1,.42.41h0a.42.42,0,0,1-.42.42h0A.41.41,0,0,1,261.15,278.15Zm-3.36,0a.41.41,0,0,1,.42-.41h0a.41.41,0,0,1,.41.41h0a.41.41,0,0,1-.41.42h0A.42.42,0,0,1,257.79,278.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.85,278.57a.41.41,0,0,1-.29-.13.3.3,0,0,1-.09-.13.45.45,0,0,1,0-.16.38.38,0,0,1,.12-.29.39.39,0,0,1,.45-.09.3.3,0,0,1,.13.09.39.39,0,0,1,.13.29.47.47,0,0,1,0,.16.44.44,0,0,1-.22.22A.42.42,0,0,1,254.85,278.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.95 166.73 185.57 166.73 183.37 122.13 298.75 122.13 300.95 166.73",
    style: {
      fill: "#FFFFFF",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.52,238.2l-.27-2.92a27.9,27.9,0,0,0,19.11-8.61,27.39,27.39,0,0,0,6.38-10.91l2.8,1a30.16,30.16,0,0,1-7,12A30.66,30.66,0,0,1,295.52,238.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.3,185a31.28,31.28,0,0,0-12.65-7.37l.71-2.8a34.51,34.51,0,0,1,13.91,8.1,33.43,33.43,0,0,1,9.27,33.87l-2.8-1A30.4,30.4,0,0,0,312.3,185Z",
    style: {
      fill: "#FFFFFF",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.68,228.74a34.05,34.05,0,0,1-10.6-22.51l2.92,0a31.31,31.31,0,0,0,32.25,29.09l.27,2.92A33.92,33.92,0,0,1,270.68,228.74Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.08,206.23a30.85,30.85,0,0,1,8.34-23.35,31.41,31.41,0,0,1,31.94-8.1l-.71,2.8A28.55,28.55,0,0,0,270.59,185,28.06,28.06,0,0,0,263,206.19Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 292.47,
    cy: 205.81,
    rx: 24.12,
    ry: 25.34,
    transform: "translate(-59.08 271.43) rotate(-45.71)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.16,254.18l-.49,2a20.78,20.78,0,0,0-15.16,1.33,19.56,19.56,0,0,0-6.93,5.79l-1.7-1.3a21.47,21.47,0,0,1,7.61-6.37A22.87,22.87,0,0,1,232.16,254.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.27,285.78a22.49,22.49,0,0,0,7,7.83l-1.14,1.7a24.88,24.88,0,0,1-7.71-8.61,23,23,0,0,1,1.45-24.7l1.7,1.3A20.89,20.89,0,0,0,208.27,285.78Z",
    style: {
      fill: "#FFFFFF",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.08,266.22a23.42,23.42,0,0,1,2.1,17.44l-2-.64a21.32,21.32,0,0,0-1.91-15.88,22.59,22.59,0,0,0-13.58-11l.49-2A24.76,24.76,0,0,1,247.08,266.22Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.18,283.66A21.59,21.59,0,0,1,238,297.29a23.47,23.47,0,0,1-23.89-2l1.14-1.7a21.33,21.33,0,0,0,21.73,1.8A19.65,19.65,0,0,0,247.16,283Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.76,
    cy: 276.46,
    rx: 17.27,
    ry: 18.14,
    transform: "translate(-129.48 245.71) rotate(-45.71)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257 127.75 253.04 127.75 243.09 142.59 254.51 157.43 258.47 157.43 247.05 142.59 257 127.75",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.85 127.75 272.81 127.75 284.24 142.59 274.28 157.43 270.31 157.43 280.27 142.59 268.85 127.75",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.8,141.18H142.51a1.78,1.78,0,0,0-1.79,1.89l.86,17.39a2,2,0,0,0,2,1.89h25.29a1.78,1.78,0,0,0,1.79-1.89l-.86-17.39A2,2,0,0,0,167.8,141.18Zm-9.55,16.18h-4.58l.32-5.53a3.24,3.24,0,0,1-1.52-2.57,2.91,2.91,0,0,1,2.93-3.08,3.27,3.27,0,0,1,3.23,3.08,2.86,2.86,0,0,1-1.26,2.57Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.47,149.26a3.24,3.24,0,0,0,1.52,2.57l-.32,5.53H156l.24,5H143.56a2,2,0,0,1-2-1.89l-.86-17.39a1.78,1.78,0,0,1,1.79-1.89h12.65l.24,5A2.91,2.91,0,0,0,152.47,149.26Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.48,139.93h0a1.77,1.77,0,0,1-1.75-1.67l-.09-1.7a9.44,9.44,0,0,0-8.72-9,8.22,8.22,0,0,0-8.72,8.7l.1,2a1.58,1.58,0,0,1-1.6,1.67h0a1.77,1.77,0,0,1-1.75-1.67l-.08-1.66a11.54,11.54,0,0,1,11-12.35A12.82,12.82,0,0,1,167,136.3l.09,2A1.57,1.57,0,0,1,165.48,139.93Z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "176.52 326.26 93.93 326.26 86.81 182.09 169.4 182.09 176.52 326.26",
    style: {
      fill: "#FFFFFF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.74 189 87.15 189 86.81 182.09 169.4 182.09 169.74 189",
    style: {
      fill: "#FFFFFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.52 326.26 93.93 326.26 93.59 319.35 176.18 319.35 176.52 326.26",
    style: {
      fill: "#FFFFFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.45,222.89l-3-1.54a20.83,20.83,0,0,0-1.72-3.71h0l.81-3.13-6.49-6.18-3.08,1h0a21.2,21.2,0,0,0-3.79-1.54h0l-1.67-2.88H84.8l-1.4,2.88a19.13,19.13,0,0,0-3.63,1.54h0l-3.17-1-5.88,6.18,1.11,3.13h0a19.54,19.54,0,0,0-1.35,3.71l-2.81,1.54.43,8.74,3,1.53h0a22,22,0,0,0,1.72,3.71h0L72,240l6.49,6.18,3.08-1a21.1,21.1,0,0,0,3.78,1.54L87,249.65h8.74l1.39-2.89h0a18.86,18.86,0,0,0,3.63-1.54l3.18,1,5.87-6.18-1.11-3.13h0a18.65,18.65,0,0,0,1.35-3.71h0l2.82-1.53ZM91.05,243.1a16.82,16.82,0,0,1-16.62-15.84,14.94,14.94,0,0,1,15.06-15.85,16.83,16.83,0,0,1,16.63,15.85A14.94,14.94,0,0,1,91.05,243.1Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6,213.63a12.85,12.85,0,0,0-12.95,13.63A14.48,14.48,0,0,0,91,240.88a12.86,12.86,0,0,0,13-13.62A14.49,14.49,0,0,0,89.6,213.63Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.38,236.4H130.49a3.39,3.39,0,0,0-3.4,3.58l1.19,24.07a3.8,3.8,0,0,0,3.76,3.58h28.18l.52,10.43,9.92-10.43h8.27a3.38,3.38,0,0,0,3.4-3.58L181.14,240A3.81,3.81,0,0,0,177.38,236.4Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.07,276.46h32a2.61,2.61,0,0,1,2.57,2.45l.81,16.44a2.3,2.3,0,0,1-2.32,2.44H127.9l.35,7.13-7.48-7.13h-5.65a2.59,2.59,0,0,1-2.56-2.44l-.81-16.44A2.3,2.3,0,0,1,114.07,276.46Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.18,217.68l-4.73-.21,2.14,9a24.77,24.77,0,0,0,4.58-4,2.27,2.27,0,0,0-.24-3.21Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.96 222.32 383.08 229.65 388.59 226.45 386.45 217.47 380.96 222.32",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.27,171.81,353,174.43c-.78.9-1.54,1.82-2.29,2.75-1.5,1.85-3,3.71-4.38,5.62a79.6,79.6,0,0,0-7.4,11.69c-.25.5-.45,1-.68,1.49l-.34.73s0-.05,0,0a2.78,2.78,0,0,0,.05,1.49,22.52,22.52,0,0,0,2.44,5.6,106.3,106.3,0,0,0,8.12,11.69l-3.77,4a62,62,0,0,1-11.43-10.85,27.56,27.56,0,0,1-4.49-7.6,12.48,12.48,0,0,1-.77-5.87,9.63,9.63,0,0,1,.42-1.83l.36-1c.24-.66.47-1.33.72-2a74,74,0,0,1,7.78-14c1.5-2.15,3-4.25,4.69-6.25.82-1,1.65-2,2.5-3s1.7-1.92,2.69-3Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.54 218.63 350.27 227.05 346.1 223.47 349.52 217.47 354.54 218.63",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.38,163.73c2.63,4.65,5.08,9.32,7.43,14.09s4.6,9.59,6.7,14.54l.17.43.19.55a6.13,6.13,0,0,1,.28,1.1c.06.34.1.69.14,1a7.44,7.44,0,0,1,0,.94,9.7,9.7,0,0,1-.17,1.71,11.3,11.3,0,0,1-.36,1.47,21.26,21.26,0,0,1-2.07,4.59,34.79,34.79,0,0,1-2.49,3.68c-.87,1.14-1.75,2.23-2.67,3.27a88.92,88.92,0,0,1-12,11.18l-3.82-4c3.2-4,6.38-8.16,9.14-12.31a45,45,0,0,0,3.55-6.2,11.81,11.81,0,0,0,.92-2.7,3.17,3.17,0,0,0,.05-.46c0-.13,0-.24,0-.26s0-.07,0,0a.17.17,0,0,0,0,.07s0,.08,0,.14a.16.16,0,0,0,0,.09s.05.08,0,0c-2.39-4.57-4.9-9.15-7.38-13.75s-5-9.21-7.4-13.81Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.56,135.32c.12.58-.09,1.12-.46,1.22s-.78-.3-.91-.88.09-1.13.46-1.22S358.43,134.74,358.56,135.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.53,136.43a22.12,22.12,0,0,1-1.7,5.65,3.35,3.35,0,0,0,2.86-.17Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.91,140.91c-.76,0-1.5-.59-2.09-1.68a11.51,11.51,0,0,1-.6-8.32c.44-1.22,1.13-1.92,1.93-2s1.57.53,2.19,1.67a10.3,10.3,0,0,1,1.08,4.11c.25,3.35-.81,6.07-2.41,6.19Zm-.66-11.48h-.07c-.58,0-1.12.65-1.49,1.65a9.89,9.89,0,0,0-.45,4,9.75,9.75,0,0,0,1,3.9c.51.95,1.14,1.47,1.72,1.42,1.27-.09,2.16-2.68,1.94-5.66a9.79,9.79,0,0,0-1-3.9C358.41,129.94,357.81,129.43,357.25,129.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,131.79a.36.36,0,0,0,.2-.06,2.73,2.73,0,0,1,2.49-.16.35.35,0,0,0,.45-.19.36.36,0,0,0-.19-.46,3.41,3.41,0,0,0-3.15.24.34.34,0,0,0-.09.48A.35.35,0,0,0,357,131.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.52,139.39c-.19,6.05-2.43,13.36,1.19,16.94,0,0-1.68,5.45-11.67,5.45-11,0-5-5.45-5-5.45,6.05-1.43,6.07-5.87,5.19-10.05Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.28,158.2c.86-1.72,1.73-4.37,0-5-1.95-.68-11.85-2.4-19.38,0a6.58,6.58,0,0,1,.1,5.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.46,409.11c-.75,0-1.48-.11-1.75-.48a.69.69,0,0,1,0-.83.86.86,0,0,1,.58-.41c1.07-.23,3,1.15,3.12,1.21a.16.16,0,0,1,.07.17.17.17,0,0,1-.13.14A9.46,9.46,0,0,1,395.46,409.11Zm-.87-1.4-.2,0a.56.56,0,0,0-.35.24c-.17.29-.08.41-.05.45.3.41,1.8.42,2.9.23A5.43,5.43,0,0,0,394.59,407.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.34,408.91l-.08,0c-.74-.41-2.14-2-2-2.83a.59.59,0,0,1,.57-.47,1,1,0,0,1,.74.23c.83.7.92,2.82.92,2.91a.18.18,0,0,1-.08.16Zm-1.37-3h-.08c-.23,0-.26.14-.27.19-.09.49.8,1.7,1.52,2.26a4.05,4.05,0,0,0-.78-2.3A.54.54,0,0,0,396,405.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.35,409.11c-1,0-1.85-.13-2.15-.55a.66.66,0,0,1,0-.76c.79-1.3,4.05.57,4.42.79a.17.17,0,0,1,.08.18.18.18,0,0,1-.14.14A13.4,13.4,0,0,1,351.35,409.11Zm-1.13-1.42a.73.73,0,0,0-.68.29c-.15.24-.08.34-.05.38.32.46,2.18.48,3.56.29A7.61,7.61,0,0,0,350.22,407.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.57,408.91h-.07c-.88-.41-2.55-2-2.41-2.81,0-.2.17-.45.66-.5a1.21,1.21,0,0,1,1,.31c.91.77,1,2.74,1,2.83a.15.15,0,0,1-.07.15A.19.19,0,0,1,353.57,408.91Zm-1.68-3h-.1c-.33,0-.35.16-.36.21-.08.51,1.05,1.74,1.93,2.28a4,4,0,0,0-.87-2.27A.92.92,0,0,0,351.89,405.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.65 408.74 354.3 408.74 354.23 391.72 361.57 391.72 361.65 408.74",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.76 408.74 398.41 408.74 395.37 391.72 402.72 391.72 405.76 408.74",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.92,407.89h8.25a.61.61,0,0,1,.61.5l1.2,6.53a1.12,1.12,0,0,1-1.13,1.3c-2.88,0-4.27-.21-7.9-.21-2.23,0-6.84.23-9.92.23s-3.37-3.05-2.1-3.33c5.71-1.24,7.91-2.94,9.78-4.57A1.82,1.82,0,0,1,397.92,407.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.38,407.89h8a.6.6,0,0,1,.6.5l1.2,6.53a1.1,1.1,0,0,1-1.11,1.3c-2.89,0-7.06-.21-10.7-.21-4.25,0-7.94.23-12.92.23-3,0-3.74-3.05-2.47-3.33,5.8-1.25,10.5-1.39,15.58-4.45A3.54,3.54,0,0,1,354.38,407.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.73,158c6.82,1.58,14,20.35,14,20.35l-14.19,9.48A110.51,110.51,0,0,1,385,172.29C381.24,163.7,386.75,156.38,393.73,158Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.73,158c6.82,1.58,14,20.35,14,20.35l-14.19,9.48A110.51,110.51,0,0,1,385,172.29C381.24,163.7,386.75,156.38,393.73,158Z",
    style: {
      fill: "#fafafa",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.33,170l5.87,17.41-.67.45s-2.68-4-5.53-9.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.89,190.81c.06,8.2.55,18.4,1.77,31.06H389c.51-6-2.15-35.46,4.76-63.88a101.07,101.07,0,0,0-13.08-1.66,145.27,145.27,0,0,0-16.7,0,75.12,75.12,0,0,0-11.38,2s-3.36,3.64-4.38,20.71C348,182.45,347.87,186.33,347.89,190.81Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.89,190.81c.06,8.2.55,18.4,1.77,31.06H389c.51-6-2.15-35.46,4.76-63.88a101.07,101.07,0,0,0-13.08-1.66,145.27,145.27,0,0,0-16.7,0,75.12,75.12,0,0,0-11.38,2s-3.36,3.64-4.38,20.71C348,182.45,347.87,186.33,347.89,190.81Z",
    style: {
      fill: "#fafafa",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.89,190.81c2.38-4.34,6.7-13.05,6.09-18l-5.8,6.28C348,182.45,347.87,186.33,347.89,190.81Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.26,165c.62,7-15.25,23.84-15.25,23.84l-12.72-10.37A82,82,0,0,1,344.18,163C351.62,155.8,359.57,157.17,360.26,165Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.26,165c.62,7-15.25,23.84-15.25,23.84l-12.72-10.37A82,82,0,0,1,344.18,163C351.62,155.8,359.57,157.17,360.26,165Z",
    style: {
      fill: "#fafafa",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.23 391.73 354.27 400.5 361.62 400.5 361.58 391.73 354.23 391.73",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.72 391.73 395.37 391.73 396.94 400.5 404.29 400.5 402.72 391.73",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.46,129.25c1.07,7.23,2.07,11.4-.72,15.95a9.49,9.49,0,0,1-16.79-.89c-2.87-6-4.15-16.84,2.16-21.42A9.58,9.58,0,0,1,377.46,129.25Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.17,127.27c-23.11-.56-4.2-14.55-4.2-14.55-3.8,6.67,7.09,6.06,9.84,3.06,3.34-3.67,9.38,1.44,8.9,5.44,3.52-.44,6.31,2.17,5,10.57s-4.06,10.77-5.5,12.82-1.32.1-6.12,1c-3.3.62-8.83-6.5-9.44-10.66A11.21,11.21,0,0,1,365.17,127.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.06,122.44s6-2.5,2-8.77C384.62,116.56,383.78,121.83,377.06,122.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.37,133.72a8.62,8.62,0,0,1-1.76,5.09c-1.49,1.92-3.2,1-3.61-1.16-.36-1.92,0-5.23,1.86-6.39S368.38,131.52,368.37,133.72Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.61,221.87S369.78,278,373.54,299c4.12,23,20,99.76,20,99.76H407s-9.56-74.86-11.54-97.67c-2.15-24.75-6.54-79.26-6.54-79.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.63,393.84c-.06,0,1.19,5.17,1.19,5.17H408l-.1-4.61Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.1,241.87c9.57,1.89,7.16,37.84,5.29,56.33-2.28-13.07-5.38-38.22-7.47-56.07A3.34,3.34,0,0,1,368.1,241.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.67,221.87s-3.14,54.93-3.2,77.33c-.07,23.3,5.12,99.6,5.12,99.6H364s3.35-74.94,4.79-97.82c1.56-25,6.67-79.11,6.67-79.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.66,214.82l3.49.28a1.91,1.91,0,0,1,1.68,2.45l-1.44,4.85a2.56,2.56,0,0,1-4,1.28,13,13,0,0,1-3.73-6.21Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.54,389.86a.13.13,0,0,1-.13-.12c-1.38-21.11-4.58-72.21-4.52-90.54.05-18.75,2.28-60.7,3-73.11a.13.13,0,1,1,.25,0c-.68,12.41-2.91,54.36-3,73.1-.06,18.32,3.14,69.41,4.52,90.53a.12.12,0,0,1-.12.13Z",
    style: {
      fill: "#fafafa",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.39,393.84c-.06,0,.5,5.17.5,5.17H365l.59-4.61Z",
    style: {
      fill: "#FFFFFF"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUi);
export default __webpack_public_path__ + "static/media/ui.57955af25f55e0a6912afb930a5fa149.svg";
export { ForwardRef as ReactComponent };